/** @jsx h */
import { h } from 'preact'

const PollOption = ({ label, id, onClick }) => {
  return (
    <div class='Poll-option'>
      <input
        type='radio'
        class='Poll-input'
        id={id}
        name='poll'
        value={id}
        onClick={() => onClick(id)}
      />
      <label class='BodyUI--regular' htmlFor={id}>
        {label}
      </label>
    </div>
  )
}

export default PollOption
